import { Component, OnInit } from '@angular/core';
import { XsI18nPipe } from '@nx-fe/pipes';
import { SspAuthorizationService } from 'sspservices/ssp-authorization.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit {
  message: string;
  username: string;
  password: string;
  isProcessing: boolean;

  constructor(private authSvc: SspAuthorizationService, private xsI18nPipe: XsI18nPipe) {}

  ngOnInit() {}

  public onLogin = () => {
    this.isProcessing = true;
    // if form data is not valid, don't proceed
    this.authSvc.login(this.username, this.password).then(
      () => {
        this.isProcessing = false;
        //Please do not change to router.navigate, we need to reload the page to get the correct user claims
        window.location.assign('/ssp/home');
      },
      error => {
        this.isProcessing = false;
        this.message = this.xsI18nPipe.transform('message_LoginError_LoginFailed_BadCredentials');
      }
    );
  };
}
